"use strict";

import Stroke from "ol/style/Stroke";

/**
 * @classdesc
 * Style-Strichlierung-Implementierung auf Basis der Openlayers Kartenbibliothek.
 *
 * @class
 * @extends gc.gis.style.GCFill
 * @memberof gc.gis.style
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.style.OLStroke = function()
{
    gc.gis.style.GCStroke.call(this);

    this._impl = new Stroke();
};
gc.gis.style.OLStroke.prototype = Object.create(gc.gis.style.GCStroke.prototype);

/**
 * @inheritDoc
 */
gc.gis.style.OLStroke.prototype.getImpl = function()
{
    return this._impl;
};

/**
 * @inheritDoc
 */
gc.gis.style.OLStroke.prototype.setWidth = function (width)
{
    this._impl.setWidth(width);
    return this;
};

/**
 * Liefert die Strichstärke.
 *
 * @abstract
 * @method
 * @public
 * @return {number} Strichstärke
 */
gc.gis.style.OLStroke.prototype.getWidth = function()
{
    return this._impl.getWidth();
};

/**
 * @inheritDoc
 */
gc.gis.style.OLStroke.prototype.setColor = function (color)
{
    gc.gis.assert.isInstance(color, gc.gis.style.GCColor);

    this._impl.setColor(color.asArray());
    return this;
};

/**
 * @inheritDoc
 */
gc.gis.style.OLStroke.prototype.getColor = function ()
{
    return new gc.gis.style.GCColor(this._impl.getColor());
};
